import { combineReducers } from '@reduxjs/toolkit';

import { cache } from './cache.slice';
import { newListing } from './new-listing.slice';
import { newListingMeta } from './new-listing-meta.slice';
import { searchParam } from './search-param.slice';
// import { modelSpecs } from './model-specs.slice';
// import { session } from './session.slice';
// import { user } from './user.slice';

const rootReducer = combineReducers({
  cache,
  newListing,
  newListingMeta,
  searchParam,
});
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
